import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../../../common/services/Campaign.service';
import { UserService } from '../../../../../../common/services/User.service';
import { FieldService } from '../../../../../../common/services/Field.service';
import { SocketService } from '../../../../../../common/services/Socket.service';
import { Observable } from 'rxjs';
import { AgentConst } from './agent.const';
import { SearchService } from '../../../../../../common/services/Search.service';
import { CommonSettingsService } from '../../../../../../common/share-data/common.setting.service';
import { CommonService } from '../../../../../../common/services/Common.service';

@Component({
  selector: 'app-campaign-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['../detail.css'],
})
export class AgentsComponent extends BaseListComponent {
  @ViewChild('templateCreateField') templateCreateField: ElementRef;
  @Input() campaign_id: any;
  @Input() campaign: any;
  public ticketFields: any = [];
  public customFields: any = [];
  public displayCondition: any = [];
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private campaignService: CampaignService,
    private sharedCommonSettings: CommonSettingsService,
    private commonService: CommonService,
    private socketService: SocketService
  ) {
    super(changeDetector, toastr, modalService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    this.is_loading = true;
    await this.loadTicketFields();
    const customFields = AgentConst.customFields(this.ticketFields);
    this.displayColumns = AgentConst.displayColumns(this.ticketFields);
    // @ts-ignore
    const { agent_campaign_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    if (agent_campaign_table_columns) {
      const saveDisplayColumns = JSON.parse(agent_campaign_table_columns);
      this.customFields = customFields.map(d => {
        try {
          const sD = saveDisplayColumns.find(sd => d.field === sd.field);
          if (sD) {
            d.display = sD.display;
          }
          return d;
        } catch (e) {
          return d;
        }
      });
      this.displayColumns = this.displayColumns.map(d => {
        const column = this.customFields.find(e => e.key === d.field);
        d.display = column ? column.display : false;
        return d;
      });
    } else {
      this.customFields = customFields;
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          agent_campaign_table_columns: JSON.stringify(this.customFields),
        })
        .toPromise();
    }
    await this.loadData();
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      if (e.type === 'select') {
        this.ticketFields.push({
          key: e.key,
          title: e.title,
          display: false,
          data: e.data,
        });
      }
    });
  }
  async loadData(request: any = {}, sort: any = {}) {
    request['fields'] = this.customFields.filter(field => field.display).map(field => field.key);
    const payload = await this.buildBasePayload(request, sort);
    payload.campaign_id = this.campaign_id;
    this.campaignService.getAgentReports(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.data = res.data.list.map(r => {
            r.display_error_call =
              parseFloat(r.total_call) - parseFloat(r.success_call) - parseFloat(r.not_answer_call);
            return r;
          });
          this.initPage(res.data.total);
          this.is_loading = false;
        } else {
          this.data = [];
          this.is_loading = false;
        }
      },
      err => {
        this.data = [];
        this.is_loading = false;
      }
    );
  }

  async handleClickFieldContact(item) {
    this.openUser(item);
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }
  async changedOptionView(data) {
    this.customFields = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        agent_campaign_table_columns: JSON.stringify(this.customFields),
      })
      .toPromise();
    this.displayColumns = this.displayColumns.map(d => {
      const column = data.find(e => e.key === d.field);
      d.display = column ? column.display : false;
      return d;
    });
    await this.loadData();
  }
  async export(request = {}, sort = {}) {
    request['fields'] = this.customFields.filter(field => field.display).map(field => field.key);
    const payload = await this.buildBasePayload(request, sort);
    this.campaignService.exportAgentReports(this.campaign_id, {}, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/detail/agents/agents.component.ts